// NodeCreatorCompact.jsx

import React from 'react';

// Context
import { useNavigation } from 'context/NavigationContext';
import { useTheme } from 'context/ThemeContext';
import { useUser } from 'context/UserContext';

// Utilities
import { getRelativeTimeShort, formatSummaryDate } from 'utilities/DateTime';
import { SectionType } from 'utilities/Enums';

// Services
import { getUser } from 'services/users/UserService';

// CSS
import './NodeCreatorCompact.css';

// Components
import ProfilePhoto from 'components/profilephoto/ProfilePhoto';

/**
 * NodeCreatorCompact
 * 
 * Displays the creator information of a node, including:
 * - Creator photo
 * - Creator name
 * 
 * @param {object} node - Node object.
 *  
 *
 * @returns {ReactNode} - NodeCreatorCompact component.
 */
const NodeCreatorCompact = ({ node }) => {

    // ----- CONTEXT ----- //

    // Global Context

    const { setCurrentSection } = useNavigation();

    // User Context
    const { setDisplayedUser } = useUser();

    // Theme Context
    const { theme } = useTheme();

    // ----- HANDLERS ----- //

    /**
     * Navigates to the user profile when a user is clicked.
     * @param {object} item - The user item that was clicked.
     */

    /**
 * Handles user click.
 *
 * @param {*} item
 */

    const handleUserClick = async (item) => {
        const fullUser = await getUser(item.key);
        setDisplayedUser(fullUser);
        setCurrentSection(SectionType.USER);
    };

    const timestamp = node?.dateCreated ? node.dateCreated : null;
    const relativeTime = timestamp ? getRelativeTimeShort(timestamp) : null;
    const absoluteTime = timestamp ? formatSummaryDate(timestamp, { includeTime: true }) : null;
    const absoluteISO = timestamp ? timestamp.toDate().toISOString() : null;

    if (!node || !node.user) return null;

    // ----- RENDER ----- //

    return (

        <div className="node-creator-compact-container">

            {/* CREATOR PHOTO */}
            <div
              className="node-creator-compact-photo"
              role="button"
              tabIndex={0}
              onClick={() => handleUserClick(node.user)}
            >

                <ProfilePhoto
                  node={node.user}
                  borderWidth={0}
                  size={20}
                />

            </div>

            {/* CREATOR NAME */}
            <div
              className="node-creator-compact-name"
            >
                {node?.user?.name}
                {relativeTime && (
                    <time
                      className="node-feed-item-elapsed"
                      style={{
                        color: theme.foregroundMuted,
                      }}
                      dateTime={absoluteISO || undefined}
                      title={absoluteTime || undefined}
                    >
                        {relativeTime}
                    </time>
                )}
            </div>

            {/* CREATOR NAME WRAPPER 
            <div className="node-creator-compact-name-wrapper">

                <div className="node-creator-compact-dot">
                    {getRelativeTimeShort(node?.dateModified)}
                </div>

            </div>
            */}

        </div>
    );
};

// Dev Tools
NodeCreatorCompact.displayName = 'NodeCreatorCompact';

export default NodeCreatorCompact;
